"use client";

import React from "react";
import { ActionBtnType } from "@/types";
import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import hasFadeAnim from "@/lib/animation/hasFadeAnim";
import hasTextMovAnim from "@/lib/animation/hasTextMovAnim";
import hasCharAnim from "@/lib/animation/hasCharAnim";

type Props = {
  title: string;
  sub_title: string;
  action_btn: ActionBtnType;
  funding: number;
  funding_title: string;
  description: string;
};

const AboutBusinessUnit = ({
  title,
  sub_title,
  action_btn,
  funding,
  funding_title,
  description,
}: Props) => {
  const containerRef = useRef<HTMLDivElement>(null!);

  useGSAP(
    () => {
      hasFadeAnim();
      hasTextMovAnim();
      hasCharAnim();
    },
    { scope: containerRef },
  );
  return (
    <section ref={containerRef}>
      <div className="inner-container-2">
        <div className="section-spacing-top">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-4 lg:col-span-4">
              <h3
                className="text-[28px] md:text-[34px] lg:text-[40px] leading-[1.5] font-bold text-black has_text_mov_anim"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            </div>

            <div className="md:col-span-8 lg:col-span-8 flex flex-col gap-8 md:gap-12">
              <p
                className="text-[24px] sm:text-[28px] lg:text-[32px] xl:text-[36px] font-superclarendon leading-[1.5] text-black text-balance has_fade_anim"
                data-fade-from="left"
                data-delay="0.15"
                data-duration="0.6"
                dangerouslySetInnerHTML={{ __html: sub_title }}
              />

              <p
                className="text-[20px] sm:text-[22px] lg:text-[24px] leading-relaxed text-black/80 font-light text-justify has_fade_anim"
                data-fade-from="bottom"
                data-delay="0.15"
                data-duration="0.6"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutBusinessUnit;
